import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import React, { memo } from 'react'
import { useDroppable } from '@dnd-kit/core'
import DataItem from './DataItem'
import classNames from 'classnames'

import SortableOperatorItem from 'src/components/pages/sales/business-rule/logic/dnd/SortableOperatorItem'
const DroppableSortable = memo(({ id, items, vertical, embedded, ...props }) => {
  const { setNodeRef } = useDroppable({ id })
  return (
    <SortableContext items={items.map((item) => item.id)} strategy={verticalListSortingStrategy}>
      <div
        ref={setNodeRef}
        className={classNames('sortable_list', { embedded: embedded })}
        style={{ display: vertical ? 'block' : 'flex' }}
      >
       
        {items.map((item, i) => {
          if (item.isData) {
            return <DataItem item={item} formulaLength={props.formulaLength ? props.formulaLength : 0} key={item.id} {...props} />
          }
          return <SortableOperatorItem item={item} key={item.id} index={i} {...props} />
        })}
      </div>
    </SortableContext>
  )
})

export default DroppableSortable
